export const transportConstants = {
	CAR: 'car',
	CAR_ELECTRIC: 'car_electric',
	MOTORCYCLE: 'motorcycle',
	MOTORCYCLE_ELECTRIC: 'motorcycle_electric',
	PUBLIC_TRANSPORT: 'public_transport',
	SCOOTER: 'scooter',
	BIKE: 'bike',
	OTHER: 'other',
};

export const transportList = [
	transportConstants.CAR,
	transportConstants.CAR_ELECTRIC,
	transportConstants.MOTORCYCLE,
	transportConstants.MOTORCYCLE_ELECTRIC,
	transportConstants.PUBLIC_TRANSPORT,
	transportConstants.BIKE,
	//transportConstants.SCOOTER,
	transportConstants.OTHER
];

export const transportListLicensePlate = [
	transportConstants.CAR,
	transportConstants.CAR_ELECTRIC,
	transportConstants.MOTORCYCLE,
	transportConstants.MOTORCYCLE_ELECTRIC,
	transportConstants.SCOOTER
]
